import { isDefined } from "@clipboard-health/util-ts";
import { isAxiosError } from "axios";
import { isObject } from "lodash";

function extractErrorMessage(message: unknown): string | undefined {
  if (typeof message === "string") {
    return message;
  }

  if (Array.isArray(message) && typeof message[0] === "string") {
    return message[0];
  }

  return undefined;
}

export function getErrorMessage(error: unknown): string | undefined {
  if (!isAxiosError(error) || !isDefined(error.response) || !isObject(error.response.data)) {
    return undefined;
  }

  const incomingErrorMessage =
    "message" in error.response.data ? extractErrorMessage(error.response.data.message) : undefined;

  return incomingErrorMessage;
}
